import { useEffect, useMemo } from "react";
import { useAppSelector } from "../../Store";
import { Graph_QL, useGetDomainLog } from "../../Services";
import { useSystem } from "../../Services/Agrisys_GqlDataCaller/SystemCalls/useSystem";
import { useLanControllers } from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useLanControllers";
import { LanControllerLogArgs } from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLanControllerLogs";

const useAttentions = (params?: { systemId?: number }) => {
  const { systemId } = params ?? {};
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})), [farm]);
  const connection = useMemo(() => (Graph_QL.create({ domain: farm })), [farm]);
  
  const { data: logData } = useGetDomainLog()
  const { call: getLanControllers, data: lanControllerData } = useLanControllers(connection)
  
  useEffect(() => {
    getLanControllers({ fetchAmount: 50 });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const lanControllers = useMemo(() => {
    return lanControllerData?.[domain]?.data?.filter(lanController => lanController.system_id === systemId) ?? [];
  }, [domain, lanControllerData, systemId])

  const lanLogs = useMemo(() => {
    if (!logData || !lanControllers.length) return [];
  
    const controllerIds = lanControllers.map(controller => controller.lan_controller_id);
  
    const controllerData = Object.entries(logData)[0]?.[1]?.data as unknown as LanControllerLogArgs[];
  
    if (!controllerData) return [];
  
    const filteredLogs = controllerData.filter(log =>
      controllerIds.includes(log.fk_lan_controllers)
    );
  
    return filteredLogs;
  }, [logData, lanControllers]);

  return {
    lanControllers,
    lanLogs
  }
}

export default useAttentions